<div class="query-row query-filter-row">
  <dcc-billboard
    label="Cohorts"
    [value]="total | number"></dcc-billboard>

  <dcc-cohort-search-input
    class="query-input"
    placeHolder="Cohort"
    [name]="this.query.name"
    (wordTyped)="onCohortNameEntered($event)"></dcc-cohort-search-input>
  <dcc-cohort-owner-input
    class="query-input"
    placeHolder="Owner"
    [owner]="this.query.creator"
    (wordTyped)="onCohortOwnerEntered($event)"></dcc-cohort-owner-input>

  <ng-select
    bindLabel="name"
    bindValue="name"
    class="ng-select-width"
    placeholder="Status"
    [items]="statusOptions"
    [multiple]="true"
    [(ngModel)]="statusOptionsSelected"
    (change)="onStatusSelectionChange($event)">
    <ng-template
      let-item="item"
      ng-option-tmp>
      <input
        type="checkbox"
        [checked]="item.selected" />
      {{ item.name }}
    </ng-template>
  </ng-select>
</div>
